import { cx } from "./cx";

type Tone = "info" | "success" | "warning" | "danger" | "neutral";

const tones: Record<Tone, { wrap: string; icon: string; role: "alert" | "status" }> = {
  info:    { wrap: "bg-[var(--c-info-soft)]    text-[var(--c-info)]    border-[var(--c-info)]/30",    icon: "ℹ", role: "status" },
  success: { wrap: "bg-[var(--c-success-soft)] text-[var(--c-success)] border-[var(--c-success)]/30", icon: "✓", role: "status" },
  warning: { wrap: "bg-[var(--c-warning-soft)] text-[var(--c-warning)] border-[var(--c-warning)]/30", icon: "⚠", role: "alert" },
  danger:  { wrap: "bg-[var(--c-danger-soft)]  text-[var(--c-danger)]  border-[var(--c-danger)]/30",  icon: "✕", role: "alert" },
  neutral: { wrap: "bg-[var(--c-surface-muted)] text-default border-default", icon: "•", role: "status" },
};

export function Alert({
  tone = "info",
  title,
  children,
  action,
  className,
  onDismiss,
}: {
  tone?: Tone;
  title?: React.ReactNode;
  children?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  onDismiss?: () => void;
}) {
  const t = tones[tone];
  return (
    <div
      role={t.role}
      aria-live={t.role === "alert" ? "assertive" : "polite"}
      className={cx("flex gap-3 rounded-md border px-3 py-2.5 text-sm", t.wrap, className)}
    >
      <span aria-hidden className="mt-0.5 select-none font-bold leading-none">{t.icon}</span>
      <div className="min-w-0 flex-1">
        {title && <div className="font-semibold">{title}</div>}
        {children && <div className={cx(title && "mt-0.5")}>{children}</div>}
        {action && <div className="mt-2">{action}</div>}
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="shrink-0 rounded p-1 text-current hover:bg-black/5"
        >
          ✕
        </button>
      )}
    </div>
  );
}
